import type { CSSObjectWithLabel } from 'react-select';

// Froala sets z-index 3700 on its editor box and 3701 on the sticky toolbar at runtime, not
// in its stylesheet. A select menu sharing a stacking context with a description field has to
// clear that or it opens behind the editor.
export const ABOVE_RICH_TEXT_EDITOR_Z_INDEX = 3800;

export const ABOVE_RICH_TEXT_EDITOR_MENU_STYLES = {
  menuPortal: (base: CSSObjectWithLabel) => ({
    ...base,
    zIndex: ABOVE_RICH_TEXT_EDITOR_Z_INDEX,
  }),
};
